import dayjs from 'dayjs';
import {getFirebaseFunction} from '../../setup/firebase';
import getAxios from '../axios/getAxios';

export async function linkEtsyAccount(token: string, onComplete?: () => void) {
  const codeResponse = await getAxios('etsy', {token}).get<{
    code: string;
  }>('loginCode', {params: {timestamp: dayjs().unix()}});

  const url = `${getFirebaseFunction('etsy/loginRedirect')}?code=${codeResponse.data.code}`;

  window.open(
    url,
    'Etsy login', // Popup window name
    'width=800,height=600,scrollbars=yes', // Popup window features
  );

  // Listen to message from child window
  if (onComplete) {
    window.addEventListener('message', onComplete, false);
  }
}
